import { machineMigrationOpportunityPath } from './machineMigrationOpportunityPath';

export const machineMigrationOpportunityOptOutPath = (appSlug: string) =>
  `${machineMigrationOpportunityPath(appSlug)}/opt_out`;
